import { isMaldivesCharterBundleOffer, MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG } from 'constants/charterFlight'
import { isFlightForceBundled } from 'lib/offer/isFlightForceBundled'
import { isLEHotel } from 'lib/offer/offerTypes'

/**
 * True for hotel tiles that must show hotel+flight (force-bundle / Maldives charter) pricing.
 * Keep in sync with LEOfferCard's "Hotel & Flight bundle" label and LEOfferForceBundlePricing.
 */
export default function isHotelFlightBundleOffer(offer: App.AnyOffer | undefined): boolean {
  if (!offer || !isLEHotel(offer)) return false
  if (isFlightForceBundled(offer)) return true
  if (offer.campaignTags?.includes(MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG)) return true
  return isMaldivesCharterBundleOffer(offer)
}
